import React from "react";
import "../style/main.scss";
import air from "../assets/images/air.jpg";

const Demo = () => {
  return (
    <div>
      <div className="demo container">
        <div className="top">
          <h4>It's finally here</h4>
          <h1>
            100,000 sales and customer service reps at the tap of a button.
          </h1>
          <p>
            Introducing the world's first ever AI that can have full on 10-40
            minute long phone calls that sound like a REAL human, with infinite
            memory, perfect recall, and can autonomously take actions across
            5,000 plus applications. It can do the entire job of a full time
            agent without having to be trained, managed or motivated. It just
            works 24/7/365.
          </p>
        </div>
        <div className="middle">
          <img src={air} alt="demo-image" />
        </div>
        <div className="bottom">
          <button>
            Create Your Free Account
            <span>And Join 70,000+ Business</span>
          </button>
          <a href="#">OrLogin To Exsisting Account</a>
        </div>
      </div>
    </div>
  );
};

export default Demo;
